@if (preCreatedBetslipEvents()?.prcrCombos?.length > 0) {
    <ng-container>
        <pre-bet-builder-list [bybBetslipEventsSignal]="preCreatedBetslipEvents()"></pre-bet-builder-list>
    </ng-container>
}
